import { useMemo } from 'react';
import { useQuery } from 'react-query';

import config from '../config';
import { useEventApi } from './api';
import { LotEventsResponse } from '../services/api/types';

export default function useLotEvents(lotId: string) {
  const api = useEventApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    LotEventsResponse,
    unknown
  >(
    [config.queryKeys.lotEvents, lotId],
    () => {
      return api.getByLot(lotId);
    },
    {
      enabled: !!lotId,
    }
  );

  const bookedDates = useMemo(() => {
    return (
      data?.events.filter((event) => {
        event.vendors = event.vendors.filter(
          (eventVendor) => eventVendor.status === 'confirmed'
        );
        return !!event.vendors[0];
      }) || []
    );
  }, [data?.events]);

  return {
    bookedDates,
    events: data?.events || [],
    isFetched,
    isFetching,
    isLoading,
    refetch,
  };
}
